import styled from '@emotion/styled';

export const ButtonWrapper = styled('div', { label: 'ButtonWrapper' })`
    display: flex;
    justify-content: space-between;
`;


interface MenuButtonWrapperType {
    isDisabled: boolean;
}

export const QuestionFormV2Wrapper = styled('div', { label: 'QuestionFormV2Wrapper' })<MenuButtonWrapperType>`
    opacity: ${({ isDisabled }): string => isDisabled === true ? '.5' : '1'};
`;
